// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1IX9f","title":"AfterFrontImage_title__3W4LU"};